<template>
    <div class="form__content form__card-credit">
        <div class="_mb-16 h2" v-html="title"></div>

        <div class="_dflex-block _mt-40-32">
            <h3 class="h3 _w-480 _mr-32-0">Укажите персональные данные</h3>
            <div>
                <div class="form__row _mb-0 _mt-0-32">
                    <div class="form__col _mb-32full">
                        <vue-suggestion
                            v-model="v$.name.$model"
                            label="Имя"
                            :class="{'_invalid': v$.name.$error, '_focus': name.length > 0}"
                            method="fio"
                            :parts="['NAME']"
                        >
                        </vue-suggestion>
                        <p class="form-error" v-if="v$.name.$error && v$.name.required?.$invalid">Поле «Имя» обязательно для заполнения</p>
                        <p class="form-error" v-if="v$.name.$error && v$.name.onlyCyr?.$invalid">Поле «Имя» не должно содержать латинские буквы и спецсимволы</p>
                    </div>
                    <div class="form__col _mb-32full">
                        <vue-suggestion
                            v-model="v$.surname.$model"
                            label="Фамилия"
                            :class="{'_invalid': v$.surname.$error, '_focus': surname.length > 0}"
                            method="fio"
                            :parts="['SURNAME']"
                        >
                        </vue-suggestion>
                        <p class="form-error" v-if="v$.surname.$error && v$.surname.required?.$invalid">Поле «Фамилия» обязательно для заполнения</p>
                        <p class="form-error" v-if="v$.surname.$error && v$.surname.cyrWithDash?.$invalid">Поле «Фамилия» не должно содержать цифры, спецсимволы и латинские буквы</p>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__col">
                        <div class="form__item">
                            <div class="form__input _focus">
                                <input id="phone" v-phone :data-value="phone" type="tel" class="d-input _focus-always" name="phone" v-mask="'+7 ###-###-##-##'" placeholder="+7" masked="true" v-model.lazy="phone" :class="{'_invalid': v$.phone.$error || phoneStartsAtEight}" />
                                <label class="form__label">Номер телефона</label>
                            </div>
                            <p class="form-error" v-if="v$.phone.$error && v$.phone.required?.$invalid">Поле обязательно для заполнения</p>
                            <p class="form-error" v-if="v$.phone.$error && v$.phone.required && v$.phone.minLength?.$invalid">Проверьте корректность номера.</p>
                            <p class="form-error" v-if="phoneStartsAtEight">Вводите номер телефона с цифры 9</p>
                        </div>
                    </div>
                </div>

                <div class="_mb-24 _mt-24">
                    <div @click="agreement = !agreement" class="checkbox">
                        <input v-model="agreement" type="checkbox" class="checkbox__input" name="agreement" :class="{'_invalid': v$.agreement.$error}" />
                        <label class="checkbox__label">
                            <p>Я соглашаюсь с&nbsp;<a target="_blank" href="/upload/medialibrary/638/aprovement_creditcards.pdf" class="link">условиями&nbsp;использования персональных&nbsp;данных</a> и&nbsp;подтверждаю согласие на&nbsp;использование <a href="#" class="link" @click.stop.prevent="$modal.show('agreement_pep')">простой электронной подписи</a></p>
                        </label>
                    </div>
                    <p class="form-error" v-if="v$.agreement.$error">Поле обязательное для заполнения.</p>
                </div>

                <div @click="sendPhone" class="button button_green">Продолжить</div>

                <div class="form__lock">
                    <span class="ico ico-safety ico_color_gray-dark ico_size_16 _mr-12"></span>
                    <span class="text-small gray-text-ninth">Мы защищаем ваши персональные данные, не&nbsp;раскрываем их третьим лицам и&nbsp;не&nbsp;распространяем без&nbsp;вашего согласия на&nbsp;это, если иное не&nbsp;предусмотрено законодательством</span>
                </div>
            </div>
        </div>

        <modal-with-yandex-captcha
            :requested="modalSmsShow"
            :phone="phone"
            endpoint="credit_card_step_0"
            @closeCaptchaSms="modalSmsShow = false"
            @smsConfirmed="sendForm"
        />

        <d-modal
            v-cloak
            name="agreement_pep"
            size="wide"
        >
            <h3 class="h2-h3m _mb-16">Соглашение об использовании простой электронной подписи</h3>
            <p class="d-modal__text p1">
                <slot name="agreement_pep"></slot>
            </p>
            <br>
        </d-modal>

    </div>
</template>

<script>
    import useVuelidate from "@vuelidate/core"
    import {required, minLength} from '@vuelidate/validators'
    import {onlyCyr, cyrWithDash} from '../../../assets/js/vue/validations'

    export default {
        name: 'CardsStartCreditForm',
        props: {
            title: {
                type: String,
                default: 'Закажите кредитную карту'
            }
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                name: '',
                surname: '',
                phone: '',
                agreement: false,
                phoneStartsAtEight: false,
                sessid: window.config.bitrix_sessid,
                tryToSend: false,
                promoFriend: false,
                modalSmsShow: false
            }
        },
        validations() {
            return {
                name: {
                    required,
                    onlyCyr
                },
                surname: {
                    required,
                    cyrWithDash
                },
                phone: {
                    required,
                    minLength: minLength(16)
                },
                agreement: {
                    isAgreed: value => value
                }
            }
        },
        methods: {
            sendPhone() {
                this.tryToSend = true;
                this.v$.$touch();

                if (!this.v$.$invalid) {
                    this.modalSmsShow = true;
                }
            },
            sendForm() {
                this.v$.$touch();
                this.tryToSend = true;

                if (!this.v$.$invalid) {
                    sessionStorage.setItem('first_name', this.name);
                    sessionStorage.setItem('second_name', this.surname);
                    sessionStorage.setItem('phone_number', this.phone);

                    window.location.href = '/cards/getcc/';
                }
            },
			urlCheck() {
				let urlStr = window.location.href;
				if ((urlStr).includes('promo/friend')) {
					return this.promoFriend = true;
				}
			},
        },
		mounted() {
			this.urlCheck();
		}
    }
</script>
